import { getProductsGridSize } from '@app/ducks';
import { GetProductUrl } from '@app/logic/products';
import { Product as ProductType } from '@typings';
import { useSelector } from 'react-redux';

import { ProductLarge } from './ProductLarge';
import { ProductMedium } from './ProductMedium';
import { ProductSmall } from './ProductSmall';

export interface ProductProps {
  productInfo: ProductType.Standard;
  getProductUrl: GetProductUrl;
  onAddToSelection?: VoidFunction;
}

export const Product = (props: ProductProps) => {
  const productsGridSize = useSelector(getProductsGridSize);

  if (productsGridSize === 'large') {
    return <ProductLarge {...props} />;
  }

  if (productsGridSize === 'medium') {
    return <ProductMedium {...props} />;
  }

  return <ProductSmall {...props} />;
};
